import { EMPTY_STRING, SplitChar } from '@common/constants';

export const getPreCostErrorMessage = (error: string) => {
  if (!error) return EMPTY_STRING;
  const arrErrors = error.split(SplitChar.DoubleColon);
  const arrErrorsLength = arrErrors.length;
  return arrErrors[arrErrorsLength - 1];
};
